export default {"src":"/_next/static/media/nasdaq_logo.5bc50877.svg","height":24,"width":85,"blurWidth":0,"blurHeight":0};